import {SetPasswordModel} from '../models/set-password.model';
import {SetPasswordDto} from '../dtos/set-password.dto';

export class AuthenticationMapper {
  static toSetPasswordDto(setPasswordModel: SetPasswordModel): SetPasswordDto {
    return {
      verificationCode: setPasswordModel.verificationCode,
      password: setPasswordModel.password,
    };
  }
}
